.panelTableStyle {
    *[class*='grid_col_2'],
    *[class*='grid_col_4'],
    *[class*='grid_col_6'],
    *[class*='grid_col_8'],
    *[class*='grid_col_10'] {
        *[class*='rowValue'] {
            color: #0000f0 !important;
        }
    }
}
